export default __webpack_public_path__ + "img/ajax-loader.gif";